import React, { useEffect } from 'react';

export default function Support() {
  useEffect(() => {
    const sub = document.getElementById('sub');
    sub.addEventListener('click', () => {
      Notification.requestPermission().then(permission => {
        alert(permission)
        if (permission === 'granted') {
          new Notification('You are subscribed to notifications!');
        }
      });
    });
    return () => {
      sub.removeEventListener('click', () => {
        Notification.requestPermission().then(permission => {
          if (permission === 'granted') {
            new Notification('You are subscribed to notifications!');
          }
        });
      });
    };
  }, []);

  return (
    <div className="support">
      <h1>Support</h1>
      <button id="sub">Notification</button>
    </div>
  );
}
